/**
 * Decide whether the running bundle is older than what is deployed.
 *
 * Kept dependency-free so the rule is unit-testable on its own; the polling
 * around it lives in `src/hooks/use-app-version-check.ts`.
 *
 * Both unknown-revision cases must return false: a build without a compiled
 * revision (local dev) or a `version.json` without one would otherwise
 * prompt every user on every poll.
 */
export function shouldPromptForUpdate(
  currentRevision: string | undefined,
  deployedRevision: string | undefined
): boolean {
  const current = currentRevision?.trim();
  const deployed = deployedRevision?.trim();

  if (!current || !deployed) {
    return false;
  }

  return current !== deployed;
}
